import { LAYOUT } from '@dofleini/auth-layout';
import LoginImageSide from '../assets/images/log-in.svg';

export const authentication = {
  image: LoginImageSide,
  background: '#ffffff',
  formBackground: '#ffffff',
  layout: LAYOUT.SIDE_BY_SIDE,
  path: '/ms-auth',
  showInviteLInk: false,
  showUserName: true,
  showAddress: false,
  //in milliseconds
  tokenExpirationTime: 2 * 60 * 60 * 1000,
  activeOnboarding: false,
  hideOnBoardingFb: true,
  hideOnBoardingGoogle: true,
};
